'use client'
import { ButtonPrimary } from '@fukku/button/Primary/ButtonPrimary'
import {
	CS_EVENT_MANAGER,
	CS_MESSAGE_CHANNEL,
	CS_URL,
} from 'content-stack/constants/constants'
import { MESSAGE_TYPES } from 'content-stack/constants/messageTypes'
import { extractDetailsFromCslp } from 'content-stack/utils/extractDetailsFromCslp'
import { IconEdit } from 'icons/components/IconEdit'
import styles from './FloatingEditButton.module.css'

type FloatingEditButtonProps = {
	readonly currentCslp: string
}

const EDIT_TEXT = 'Edit'

export function FloatingEditButton({ currentCslp }: FloatingEditButtonProps) {
	const handleClick = (eClick: React.MouseEvent<HTMLButtonElement>) => {
		eClick.stopPropagation()
		eClick.preventDefault()

		const cslpPath = (eClick.currentTarget as HTMLElement).getAttribute(
			'data-current-cslp'
		)

		if (cslpPath) {
			const { contentTypeUid, entryUid, locale, fieldPathWithIndex } =
				extractDetailsFromCslp(cslpPath)

			window.parent.postMessage(
				{
					eventManager: CS_EVENT_MANAGER,
					metadata: {
						hash: `${MESSAGE_TYPES.SCROLL}-${crypto.randomUUID().split('-')[0]}`,
						nature: 'REQUEST',
					},
					channel: CS_MESSAGE_CHANNEL,
					type: MESSAGE_TYPES.SCROLL,
					payload: {
						field: fieldPathWithIndex,
						content_type_uid: contentTypeUid,
						entry_uid: entryUid,
						locale,
					},
				},
				CS_URL
			)
		}
	}

	return (
		<ButtonPrimary
			onClick={handleClick}
			data-current-cslp={currentCslp}
			className={styles.button}
		>
			<div className={styles.container}>
				<IconEdit width={16} height={16} className={styles.icon} />
				{EDIT_TEXT}
			</div>
		</ButtonPrimary>
	)
}
